/// <reference path="../declarations.d.ts" />

import 'core-js/es';
import "core-js/features/promise/any";
import "core-js/stable/promise/finally";
import "core-js/stable/array/flat";
import "whatwg-fetch";
import "abortcontroller-polyfill";
import 'raf/polyfill';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import './index.scss';
import AppContainer from './components/app-container/app-container';

// Sentry.init({
// 	dsn: "https://d48bed305c3e42b5a2ef5fdce769d606@o394454.ingest.sentry.io/5244575",
// 	integrations: [Sentry.replayIntegration()],
// 	tracesSampleRate: 1,
// 	sampleRate: 1,
// 	release: process.env.REACT_APP_GIT_VERSION,
// 	maxValueLength: 1000,
// 	ignoreErrors: [],
// 	replaysSessionSampleRate: 0.1,
// 	replaysOnErrorSampleRate: 1.0,
// });

ReactDOM.render(
	<Provider store={store}>
		<AppContainer />
	</Provider>,
	document.getElementById('root')
);